
import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import LangSelect from '@/components/Lang/index.vue';
import variables from '@/styles/_variables.scss';
import NavbarItem from './NavbarItem.vue';
import defaultLogo from '@/assets/image/common/logo.png';
import geaLogo from '@/assets/image/common/logo-gea.png';
@Component({
  name: 'Navbar',
  components: {
    NavbarItem,
    LangSelect,
  },
})
export default class extends Vue {

  get isMobile() {
    return AppModule.narrow;
  }
  get langEN() {
      if (AppModule.language === 'en-us') {
          return true;
      } else {
          return false;
      }
  }
  get userName() {
    return `${this.$t('navbar.webcomeBack')} ${UserModule.name || this.$t('navbar.noName')}`;
  }
  get variables() {
    return variables;
  }
  get routes() {
    // return (this.$router as any).options.routes.filter((v: any) => v.name === 'home')[0].children;
    return (this.$router as any).options.routes
  }
  get currentCompany() {
    const { company } = this.$route.query;
    return Array.isArray(company) ? company[0] || '' : company || '';
  }
  get logoSrc() {
    return this.currentCompany.toLowerCase() === 'gea' ? geaLogo : defaultLogo;
  }
  get activeMenu() {
    const route = this.$route;
    const { meta, path }: any = route;
    // if set path, the navbar will highlight the path you set
    if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
  }
  @Ref() public linkwrap!: HTMLDivElement;
  public selectMenuIndex = -1;
  public curMenuIndex = -1;
  public navOpen = false;
  public async logout() {
    await UserModule.LogOut().catch((err) => err);
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }
  public goMain() {
    this.navigateTo({
      path: '/index',
      query: this.currentCompany ? { company: this.currentCompany } : {},
    });
  }
  public toggleSideMenu() {
    this.navOpen = !this.navOpen;
    this.selectMenuIndex = -1;
  }
  public backMainSideMenu() {
    this.selectMenuIndex = -1;
  }
  @Watch('$route', { immediate: true })
  public onRouteChange(route: any) {
    if (this.isMobile) {
      this.navOpen = false;
      this.selectMenuIndex = -1;
    }
  }
  @Watch('isMobile')
  public onNarrowChange(narrow: boolean) {
    if (!narrow) {
      this.navOpen = false;
      this.selectMenuIndex = -1;
    }
  }
  private navigateTo(target: any) {
    const { route } = this.$router.resolve(target);
    if (route.fullPath === this.$route.fullPath) {
      return;
    }
    this.$router.push(target).catch((err) => err);
  }
}
